"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var PriceAdviceInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var value = values.project.behavioural_advice.price_comparison_advice_taken;
    return (react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.behavioural_advice) === null || _b === void 0 ? void 0 : _b.price_comparison_advice_taken, label: trans('project:slhh::labels.price-comparison-advice-taken'), showOther: value === enums_1.BooleanOther.OTHER, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.behavioural_advice) === null || _d === void 0 ? void 0 : _d.price_comparison_advice_taken_other, label: trans('project:slhh::labels.price-comparison-advice-other') },
            react_1.default.createElement(__1.TextArea, { fast: true, name: "project.behavioural_advice.price_comparison_advice_taken_other", maxLength: 5000 })) },
        react_1.default.createElement(__1.Select, { options: {
                switch_during: trans('project:slhh::enum.price-comparison-action.switch_during'),
                switch_following: trans('project:slhh::enum.price-comparison-action.switch_following'),
                against_switch: trans('project:slhh::enum.price-comparison-action.against_switch'),
                other: trans('project:slhh::enum.price-comparison-action.other'),
            }, name: "project.behavioural_advice.price_comparison_advice_taken" })));
};
exports.default = PriceAdviceInput;
//# sourceMappingURL=PriceAdviceInput.js.map